import { Component, OnInit, signal, WritableSignal } from '@angular/core';
import { InputComponent } from "../../shared/input/input.component";
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ListsService } from '../../services/lists.service';
import { ConfigInput, ConfigSelected } from '../../interfaces/interfaces';
import { LoaderService } from '../../services/loader.service';
import { SecurityService } from '../../services/security.service';
import { SelectedComponent } from "../../shared/selected/selected.component";
import { CommonModule } from '@angular/common';
import { ModalComponent } from "../../shared/modal/modal.component";
import { Router } from '@angular/router';

@Component({
  selector: 'app-pap',
  imports: [
    InputComponent,
    SelectedComponent,
    CommonModule,
    ModalComponent
],
  templateUrl: './pap.component.html',
  styleUrl: './pap.component.css'
})
export class PapComponent implements OnInit{

  form: FormGroup;
  savingCategories = [];
  targets = [];
  months: string[] = [];
  showPaymentMethods = signal(true);
  showModal = signal(false);
  showTerms = signal(false);
  allowTerms = false;
  nexRoute = '';

  dataInputs: WritableSignal<ConfigInput[]> = signal([
    { label: 'Cuota de ahorro', subLabel: '(mensual)', formName: 'quota', placeholder: '', type: 'number', defaultValue: '', enabled: true, validation: [Validators.required, Validators.min(50000), Validators.max(49999999)], textError: 'El valor debe ser superior a 50,000 e inferior a 49,999,999'},
  ])

  dataSelected: WritableSignal<ConfigSelected[]> = signal([
    { label: 'Duración del ahorro', subLabel: '', formName: 'duration', placeholder: '', type: 'text', defaultValue: '', enabled: true, validation: [ Validators.required], textError: 'Por favor selecciona un elemento de la lista', options: signal([])},
    { label: 'Motivo', subLabel: '', formName: 'targetId', placeholder: '', type: 'text', defaultValue: '', enabled: true, validation: [ Validators.required], textError: 'Por favor selecciona un elemento de la lista', options: signal([])},
  ])

  paymentMethods: {value: number, label: string }[] = [
  ]


  constructor(
    private _title: Title,
    private _listService: ListsService,
    private _loaderService: LoaderService,
    private _securityServie: SecurityService,
    private _router: Router,
  ){
    this._title.setTitle('Onboarding Digital | PAP');

    this.form = new FormGroup({
      quota: new FormControl(null, [Validators.required]),
      savingCategoryId: new FormControl(null, [Validators.required]),
      duration: new FormControl(null, [Validators.required]),
      targetId: new FormControl(null, [Validators.required]),
      paymentMethodId: new FormControl(null, [Validators.required]),
    });

    this.form.get('quota')?.valueChanges.subscribe((value:any) => {
      this.monthsByQuota();
    });

    this.form.get('duration')?.valueChanges.subscribe((value:any) => {
      this.getTargetByCategoryId();
    });
  }

  ngOnInit(): void {
    this.getSavingCategories();
    this.getPaymenthsMethods();
    this.getPrincipalActivityTypeId();
    this.getTargets();
    this._loaderService.hide();
  }

  getPrincipalActivityTypeId(){
    this._securityServie.getPrincipalActivityTypeId().subscribe({
      next: (response:any) => {
        this.showPaymentMethods.set( (response.principalActivityTypeId === 2) ? false : true );
        if(!this.showPaymentMethods()){
            this.form.get('paymentMethodId')?.setValue(1);
        }
      },
      error: (error: any) => {
        console.error("ERROR: ", error);
      }
    })
  }

  getPaymenthsMethods(){
    this._listService.getPaymentMethods().subscribe({
      next: (response:any[]) => {
          this.paymentMethods = response;
      },
      error: (error: any) => {

      }
    })
  }

  getTargets(){
    this._loaderService.show();
    this._listService.getTargets().subscribe({
      next: (response:any) => {
        this.targets = response;
        this._loaderService.hide();
      },
      error: (error:any) => {
        console.log(error);
        this._loaderService.hide();
      }
    })
  }

  getSavingCategories(){
    this._loaderService.show();
    this._securityServie.getCategories().subscribe({
      next: (response:any) => {
        this.savingCategories = response?.savingCategories;
        this._loaderService.hide();
      },
      error: (error:any) => {
        console.log(error);
        this._loaderService.hide();
      }
    })
  }

  agreeTerms(event:any){
    this.allowTerms = event.target.checked;
  }

  selectPaymentMethod(payment: any) {
    this.nexRoute = payment.url;
    this.form.get('paymentMethodId')?.setValue(payment.value);
}

  getTargetByCategoryId(){
    const categoryId = Number(this.form.get('savingCategoryId')?.value);
    const duration = Number(this.form.get('duration')?.value);

    if(!categoryId || !duration){
      return
    }

    const targets: WritableSignal<any[]> = signal([]);

    this.targets.find((s:any) => {
      if(Number(s.categoryId) === categoryId){
        targets().push(s);
      }
    })

    this.dataSelected().at(1)?.options.update(targets);
    console.log(this.dataSelected().at(1)?.options());

  }

  monthsByQuota() {
    // Faltan mejoras a esta funcion
    const raw = this.form.get('quota')?.value;
    const quota = Number(String(raw).replace(/\D/g, ''));

    if (!this.savingCategories || this.savingCategories.length === 0) return;

    const durationConfig = this.dataSelected().find(item => item.formName === 'duration');
    if (!durationConfig) return;

    const optionsSignal = durationConfig.options as WritableSignal<any[]>;

    if (!quota || isNaN(quota)) {
      if (optionsSignal?.set) optionsSignal.set([]);
      else durationConfig.options().length = 0;
      return;
    }


    const category: any = this.savingCategories
      .filter((c: any) => quota >= c.minSaving && quota <= c.maxSaving)
      .reduce((best: any, current: any) => {
        if (!best) return current;
        const diffBest = quota - best.minSaving;
        const diffCurrent = quota - current.minSaving;

        if (diffCurrent < diffBest) {
          return current;
        }

        if (diffCurrent === diffBest && current.minSaving > best.minSaving) {
          return current;
        }

        return best;
      }, null);

      this.form.get('savingCategoryId')?.setValue(Number(category.id));


    if (!category) {
      if (optionsSignal?.set) optionsSignal.set([]);
      else durationConfig.options().length = 0;
      return;
    }

    const months: { label: string, value: number }[] = [];
    for (let i = Number(category.minDuration); i <= Number(category.maxDuration); i++) {
      months.push({ label: `${i} meses`, value: i });
    }

    if (optionsSignal?.set) {
      optionsSignal.set(months);
    } else {
      durationConfig.options().length = 0;
      durationConfig.options().push(...months);
    }

    // console.log('categoria encontrada:', category, '-> months:', months);
  }

  handleValue(event: {formName:string, value:string | number}) {
    this.form.get(event.formName)?.setValue(event.value);
  }

  changeModal(){
    this.showModal.set(!this.showModal())
    this.showTerms.set(!this.showTerms())
  }

  public getTarget() {
      const targetId = Number(this.form.get('targetId')?.value);
      
      if (targetId === null || targetId === undefined || isNaN(targetId)) {
          return '';
      }

      const item:any = this.targets.find((item: any) => item.value === targetId);
      
      return item ? item.label : '';
  }

  saveData(){
    this._loaderService.show();
    this._securityServie.setPapData({ ...this.form.value, authorization: this.allowTerms }).subscribe({
      next: (response:any ) => {
        this.next();
      },
      error: (error:any) => {
        this._loaderService.hide();
        console.error("ERROR: ", error);
      }
    })
  }

  async next() {
    switch (Number(this.form.get('paymentMethodId')?.value)) {
      case 1:
        this._router.navigateByUrl('/app/pap-cash');
        break;
      case 2:
        localStorage.clear();
          window.location.href = this.nexRoute;
        break;
      case 3:
        this._router.navigateByUrl('/app/pap-finish');
        break;
    }
  }

  public getPaymentMethod() {
      const paymentMethodId = Number(this.form.get('paymentMethodId')?.value);
      
      if (paymentMethodId === null || paymentMethodId === undefined || isNaN(paymentMethodId)) {
          return '';
      }

      const item:any = this.paymentMethods.find((item: any) => item.value === paymentMethodId);
      
      return item ? ((item.label === 'Fincomercio') ? 'Descuento de Nomina' : item.label ) : '';
  }
}
